import React from 'react';
import { View } from 'react-native';

import { scale } from '@components/frame';
import TouchableElement from '@components/common/touchableElement';
import Svg from '@styles/icons/svg';

const RadioButton = (props) => {
  const { C, isSelected, onSelect, type } = props;

  const renderButton = () => {
    switch (type) {
      case 'dot':
        return (
          <View
            style={[
              {
                height: 18,
                width: 18,
                borderRadius: 12,
                borderWidth: 1,
                borderColor: isSelected ? C('Selected/Light/Primary') : C('Label/Light/Quinary'),
                alignItems: 'center',
                justifyContent: 'center',
                alignSelf: 'center',
              },
            ]}
          >
            {isSelected ? (
              <View
                style={{
                  height: 10,
                  width: 10,
                  borderRadius: 6,
                  backgroundColor: C('Selected/Light/Primary'),
                }}
              />
            ) : null}
          </View>
        );
      default:
        return (
          <Svg
            icon={`${isSelected ? 'selected' : 'unselected'}`}
            width={scale(24)}
            height={scale(24)}
            color={`${isSelected ? 'Selected/Light/Primary' : 'Label/Light/Quinary'}`}
          />
        );
    }
  };

  return (
    <TouchableElement
      style={{
        flexDirection: 'row',
        alignItems: 'center',
      }}
      onPress={() => {
        if (onSelect) {
          onSelect();
        }
      }}
    >
      {({ boxStyle }) => (
        <View
          style={[
            boxStyle,
            {
              height: scale(24),
              width: scale(24),
            },
          ]}
        >
          {renderButton()}
        </View>
      )}
    </TouchableElement>
  );
};

export default RadioButton;
